import {
    Main
} from './class/main-index.js';
// import {
//     Main
// } from './class/vimeo-test.js';

var APP = new Main();
APP.init();